/*
 * @Author: lixiang
 * @Date: 2026-10-23 09:59:52
 * @Description: 开发者测试路由
 * @FilePath: /Flash/flashhr/backyard-ms/src/router/testRoutes.js
 * @LastEditTime: 2026-10-26 16:41:11
 * @LastEditors: lixiangyun@flashexpress.com
 */

const isDevelopmentMode = ['development', 'testing'].includes(process.env.MODE) // 开发模式

import Layout from '@/layout'

const _import = path => () => import(`@/views/${path}`)

const developmentRoute = [
  {
    path: '/test',
    component: Layout,
    name: 'DeveloperTest',
    meta: {
      title: '开发者',
      icon: 'example'
    },
    hidden: !isDevelopmentMode, // 仅开发环境显示
    children: [
      {
        path: 'fileToUpload',
        name: 'fileToUpload',
        component: _import('test/fileToUpload/index'),
        meta: {
          title: '选择文件上传'
        }
      }
    ]
  }
]

export default developmentRoute
